module.exports =(function() {
  return function(context) {
    return (function() {
      var $c, $e, $o, i, j, len, ref;
      $e = function(text, escape) {
        return ("" + text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;').replace(/\//g, '&#47;').replace(/"/g, '&quot;');
      };
      $c = function(text) {
        switch (text) {
          case null:
          case void 0:
            return '';
          case true:
          case false:
            return '' + text;
          default:
            return text;
        }
      };
      $o = [];
      $o.push("<div class='content-wrapper-inner'>\n  <div class='section-wrapper'>\n    <h1>What you cover</h1>\n    <p>\n      Niche expertise is important to all of our clients. Let us know what topics you covered in each project. If you think we are missing a topic,&nbsp;\n      <a href='mailto:support@contently.com'>please notify us</a>\n      \.\n    </p>\n  </div>\n  <div class='profile-nav-container section-wrapper'>\n    <div class='add-projects-tabs'>\n      <h4 class='active'>Add topics</h4>\n    </div>\n  </div>\n  <div class='maskable section-wrapper' id='projects'>\n    <div class='content divider no-line registration-add-topics'>\n      <div class='js-projects-list loading'>");
      ref = Array(5);
      for (j = 0, len = ref.length; j < len; j++) {
        i = ref[j];
        $o.push("        <div class='js-project-row list-item-wrapper'>\n          <div class='collapsible-container list-item'>\n            <span class='icon icon-move sort-handle'></span>\n            <div class='collapsible-header'>\n              <div class='flex-wrapper'>\n                <div class='flex-checkbox'>\n                  <div class='checkbox-toggle'></div>\n                </div>\n                <div class='flex-column js-toggle-collapsible'>\n                  <h5></h5>\n                  <div class='subtext'></div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>");
      }
      $o.push("        <div class='gradient-tint'></div>\n      </div>\n    </div>\n    <div class='actions divider js-actions'>\n      <a class='back-button button medium secondary' href='" + ($e($c(this.addProjectsUrl))) + "'>Add more projects</a>\n      <a class='button hidden js-next-page medium transparent'>View portfolio</a>\n      <a class='button js-add-topics medium primary'>Add topics</a>\n    </div>\n  </div>\n</div>");
      return $o.join("\n").replace(/\s([\w-]+)='true'/mg, ' $1').replace(/\s([\w-]+)='false'/mg, '').replace(/\s(?:id|class)=(['"])(\1)/mg, "").replace(/[\s\n]*\u0091/mg, '').replace(/\u0092[\s\n]*/mg, '');
    }).call(context);
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./app/javascript/backbone/projects/templates/registration_topics.js.hamlc
// module id = 1535
// module chunks = 2